import { ShieldCheck, PenTool } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { SENDER_FIELD_INPUT_TYPE } from '../../hooks/useSenderFillableFields';

// Requester/Admin (sender_fillable) fields panel — shown above the Send
// button on every send surface that has any (Send Packet, Batch Send, Bulk
// Send). One entry per (template, field) pair from useSenderFillableFields.
export default function SenderFieldsPanel({
  senderFillableFields, senderFieldValues, setSenderFieldValues, senderFieldKey, setSigningKey,
  testIdPrefix = 'sender-fillable',
}) {
  if (!senderFillableFields.length) return null;
  return (
    <div className="space-y-2 bg-indigo-50 border border-indigo-200 rounded-lg p-4" data-testid={`${testIdPrefix}-section`}>
      <p className="text-xs font-semibold text-indigo-700 flex items-center gap-1.5">
        <ShieldCheck className="w-3.5 h-3.5" /> Requester fields — required before sending
      </p>
      {senderFillableFields.map(({ templateId, templateName, field }) => {
        const key = senderFieldKey(templateId, field.id);
        const value = senderFieldValues[key];
        return (
          <div key={key} className="space-y-1">
            <Label className="text-xs">
              {field.label}
              <span className="text-muted-foreground font-normal"> · {templateName}</span>
            </Label>
            {field.field_type === 'signature' ? (
              value ? (
                <div className="flex items-center gap-2 p-1.5 border border-indigo-200 rounded bg-white">
                  <img src={value} alt="Signature" className="h-8 max-w-[120px] object-contain" />
                  <Button type="button" size="sm" variant="ghost" className="h-6 text-[10px] px-2" onClick={() => setSigningKey(key)}>
                    Re-sign
                  </Button>
                </div>
              ) : (
                <Button
                  type="button" size="sm" variant="outline"
                  className="w-full h-8 text-xs gap-1.5 border-indigo-300 text-indigo-700 hover:bg-indigo-100"
                  onClick={() => setSigningKey(key)}
                  data-testid={`${testIdPrefix}-sign-now-${field.id}`}
                >
                  <PenTool className="w-3.5 h-3.5" /> Sign now
                </Button>
              )
            ) : field.field_type === 'checkbox' ? (
              <div className="flex items-center gap-2 h-8">
                <Checkbox
                  checked={value === true}
                  onCheckedChange={(checked) => setSenderFieldValues(prev => ({ ...prev, [key]: checked === true }))}
                />
              </div>
            ) : (
              <Input
                type={SENDER_FIELD_INPUT_TYPE[field.field_type] || 'text'}
                value={value || ''}
                onChange={(e) => setSenderFieldValues(prev => ({ ...prev, [key]: e.target.value }))}
                placeholder={`Enter ${field.label.toLowerCase()}`}
                className="h-8 text-xs"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
